import Timeline from '../../Timeline';
import { adjustTimelineElementRight } from './adjust-timeline-element-right';

export function onResizeHandleRightScrollMove({
  timeline,
  mouseMoveChangeAmount,
  initialScroll,
  _width,
  resizeHandlerElement,
}: {
  timeline: Timeline;
  mouseMoveChangeAmount: number;
  initialScroll: number;
  _width: number;
  resizeHandlerElement: HTMLElement;
}): void {
  const newScroll = timeline.timelineBody.virtualScroller.scrollElement.scrollLeft;

  const changeAmount = mouseMoveChangeAmount + newScroll - initialScroll;
  const newWidth = _width + changeAmount;

  adjustTimelineElementRight({
    newWidth,
    element: resizeHandlerElement.parentElement,
    changeAmount,
    width: _width,
  });
}
